import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {ETAPService} from "abastecemento/service";

const ViewETAPDocumentPanel = () => {
    const {idEtap} = useParams();

    const handleSetFeaturedImage = documentId => {
        return ETAPService.updateWithPatch({
            id: idEtap,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return ETAPService.updateWithPatch({
            id: idEtap,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewETAPDocumentPanel;
